import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Options } from 'humanize-duration';
import { ContactType } from 'src/app/core/models/common/contact.model';
import { LeadSummary } from 'src/app/core/models/lead/lead-summary.model';
import { NotificationAlertLevel } from '../../notification-alert-level.enum';

@Component({
    selector: 'banner-notification-lead-offer',
    templateUrl: './banner-notification-lead-offer.component.html',
    styleUrls: ['./banner-notification-lead-offer.component.scss'],
    standalone: false
})
export class BannerNotificationLeadOfferComponent implements OnInit {

  @Input() set lead(offeredLead: LeadSummary) {
    this.contactsSummary = this.getContactSummary(offeredLead)
    this.province = offeredLead.province?.name ?? ''
    this.offerEndDate = offeredLead.offer?.expiration
  }

  @Output() accepted = new EventEmitter()
  @Output() refused = new EventEmitter()

  contactsSummary: string = ''
  province: string = ''
  offerEndDate: Date | undefined

  notificationAlertLevel = NotificationAlertLevel

  constructor() { }

  ngOnInit(): void {
  }

  onDeclineClick() {
    this.refused.emit()
  }

  onAcceptClick() {
    this.accepted.emit()
  }

  readonly humanizeConfig: Options = {
    language: 'it',
    units: ['d', 'h', 'm', 's'],
    largest: 1,
    round: true
  }

  private getContactSummary(lead: LeadSummary) {

    const emailsCount = lead.contacts.filter(c => c.type == ContactType.Email).length
    const mobilesCount = lead.contacts.filter(c => c.type == ContactType.Phone).length

    if (!emailsCount && !mobilesCount) return '';

    let summary: string = '';

    if (emailsCount) summary += `${emailsCount} email`;
    if (emailsCount && mobilesCount) summary += `, `;
    if (mobilesCount) summary += `${mobilesCount} mobile`;


    return summary;
  }

}
